// export const appHomeUrl = "http://localhost:3000/home";
// export const origin= "*"



// export const msalConfig = {
//     auth: {
//         //onsite
//         // clientId: "e2281eb3-4349-4386-a499-91ff8ba91fb8",
//         //offshore
//         // clientId: "44327953-b778-4885-b8bc-e94aa9014baa",
//         // authority: "https://login.microsoftonline.com/3e861d16-48b7-4a0e-9806-8c04d81b7b2a",
//         // knownAuthorities: ["massgov.onmicrosoft.com"],

//         clientId: "f64bfc49-8574-45d4-911a-2b0f971da6ef",
//         authority: "https://login.microsoftonline.com/cde49feb-c422-4e87-aad9-d77c6373b5d4",
//         knownAuthorities: ["login.microsoftonline.com/cde49feb-c422-4e87-aad9-d77c6373b5d4"],
//         redirectUri: appHomeUrl,
//         postLogoutRedirectUri: appHomeUrl,
//         // response_type: "id_token",
//         // prompt: "login",
//     },
//     cache: {
//         cacheLocation: 'localStorage',
//         storeAuthStateInCookie: false
//     }

// };

// // Add here scopes for id token to be used at MS Identity Platform endpoints.
// export const loginRequest = {
//     scopes: ['openid', 'profile', 'user.read', 'email'],
//     extraQueryParameters: {},
//     // authority: "https://login.microsoftonline.com/3e861d16-48b7-4a0e-9806-8c04d81b7b2a",
//     authority: "https://login.microsoftonline.com/cde49feb-c422-4e87-aad9-d77c6373b5d4",
// };


// export const postLogoutRedirectUri = {
// redirectUri: `${appHomeUrl}`
// }
//export const appHomeUrl = "https://mplb.martinrea.com/home";
 export const appHomeUrl = "https://qa-mplb.martinrea.com/home";
 //export const appHomeUrl = "http://localhost:3000/home";

export const msalConfig = {
    auth: {
        //Kyyba Test
        // clientId: "9509e7b4-bd4d-4d9d-b27c-f211e391cc6a",
        // authority: "https://login.microsoftonline.com/cde49feb-c422-4e87-aad9-d77c6373b5d4",
        // knownAuthorities: ["kyybaus.onmicrosoft.com"],

        //Mindcan test
        clientId: "0e2ab151-9b84-4b98-93a9-0911cfb56b36",
        authority: "https://login.microsoftonline.com/90eaee3c-4074-426d-994b-75a5053978df",
        knownAuthorities: ["mindcaninc.com"],

        //Martinrea QA
        // clientId: "485931c8-7b42-4283-b230-ded733ce106a",
        // authority: "https://login.microsoftonline.com/09fa1f64-6758-4a1d-92b3-efd011557976",
        // knownAuthorities: ["martinrea.com"],

        //Martinrea PROD
        // clientId: "acdc69ae-4849-407d-93cd-f5690bcb306b",
        // authority: "https://login.microsoftonline.com/09fa1f64-6758-4a1d-92b3-efd011557976",
        // knownAuthorities: ["martinrea.com"],

        redirectUri: appHomeUrl,
        postLogoutRedirectUri: appHomeUrl,
        // response_type: "id_token",
        // prompt: "login",
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
    scopes: ['openid', 'profile', 'user.read', 'email'],
    extraQueryParameters: {},
     //Kyyba Test
    // authority: "https://login.microsoftonline.com/cde49feb-c422-4e87-aad9-d77c6373b5d4",

    // Mindcan test
   authority: "https://login.microsoftonline.com/90eaee3c-4074-426d-994b-75a5053978df" //Mindcan test

    //Martinrea QA
   // authority: "https://login.microsoftonline.com/09fa1f64-6758-4a1d-92b3-efd011557976" //Martinrea test

    //Martinrea PROD
   // authority: "https://login.microsoftonline.com/09fa1f64-6758-4a1d-92b3-efd011557976" //Martinrea test
};


export const postLogoutRedirectUri = {
   //redirectUri: "http://localhost:3000/login"
    redirectUri: "https://qa-mplb.martinrea.com/login"
   //redirectUri: "https://mplb.martinrea.com/login"
}
